import React, { PureComponent } from 'react';
import {
  Nav,
  NavItem,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Col,
  Container,
  Row,
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import URI from 'urijs';
import { omit, compact } from 'underscore';
import cx from 'classnames';
import numeral from 'numeral';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';
import cmpStyle from '../../components/Components.module.scss';

// ducks
import { fetch } from '../../ducks/GolfCourseSearch';

// components
import LoadError from '../../components/load-error/load-error';

// containers
import PropertySearch from '../PropertySearch/PropertySearch';
import PropertyDetailMap from '../PropertyDetail/PropertyDetailMap';

const PROPERTY_SEARCH_TITLES = {
  residential: 'Homes For Sale within 1 Mile Radius of ',
  residential_income: 'Homes For Sale within 1 Mile Radius of ',
  commercial: 'Commercial Properties within 1 Mile Radius of ',
  rental: 'Rentals within 1 Mile Radius of ',
  land: 'Lot & Land within 1 Mile Radius of '
};

class GolfCourse extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showMap: false
    };
  }

  render() {
    const { error, id, record, searchURI, detailURI, isLoading, loaded, propertyClass } =
      this.props;
    const isLoaded = !isLoading && loaded === id;

    return (
      <Container className={cx(cmpStyle.detail, styles.GolfCourseDetail)}>
        <Row>
          <Breadcrumb>
            <LinkContainer exact to="/">
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to="/find-golf-course">
              <BreadcrumbItem>
                <Link to="/find-golf-course">Golf Course Search</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to={`/golf-course/${id}`}>
              <BreadcrumbItem>
                <Link to={`/golf-course/${id}`}>{id ? id.replace(/(-)/g, ' ') : id}</Link>
              </BreadcrumbItem>
            </LinkContainer>
          </Breadcrumb>
        </Row>
        <Route
          path="/golf-course/:id"
          render={() => (
            <Container className={`${BS.breadcrumb2}`}>
              <Row>
                <Nav horizontal="space-between" className={`${BS.mt0} ${BS.mb3}`}>
                  {searchURI && !detailURI && (
                    <NavItem>
                      <Button color="link" tag={Link} to={searchURI}>
                        &lt; Back
                      </Button>
                    </NavItem>
                  )}
                  {detailURI && (
                    <NavItem>
                      <Button color="link" tag={Link} to={detailURI}>
                        &lt; Back
                      </Button>
                    </NavItem>
                  )}
                </Nav>
              </Row>
            </Container>
          )}
        />
        {isLoading && <div className={BS.loadingMask}>Loading</div>}
        {error && <LoadError error={error} retry={() => this.reload()} />}
        {isLoaded && (
          <div className={cmpStyle.header}>
            <div>
              <h4>{record.get('name')}</h4>
              <div>
                <small>{this.getAddress(record)}</small>
              </div>
            </div>
          </div>
        )}
        {isLoaded && (
          <React.Fragment>
            <Row className={cx(cmpStyle.details, BS.gutters1)}>
              <Col xs={12} sm={4}>
                {this.renderMap()}
              </Col>
              <Col xs={12} sm={4}>
                <ListGroup className={`${cmpStyle.list} ${BS.p1}`}>
                  <ListGroupItem>
                    <label>Number of Homes:</label>
                    <strong>{numeral(record.get('numHomes')).format('0,0')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Par:</label>
                    <strong>{record.get('par')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Course Length:</label>
                    <strong>{record.get('courseLength')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Course Rating:</label>
                    <strong>{record.get('rating')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Course Slope:</label>
                    <strong>{record.get('slope')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Course Architect:</label>
                    <strong>{record.get('architect')}</strong>
                  </ListGroupItem>
                </ListGroup>
              </Col>
              <Col xs={12} sm={4}>
                <ListGroup className={`${cmpStyle.list} ${BS.p1}`}>
                  <ListGroupItem>
                    <label>Phone:</label>
                    <strong>{record.get('phone')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Pro Shop Phone:</label>
                    <strong>{record.get('proShopPhone')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>URL:</label>
                    <strong>
                      <a
                        href={record.get('url')}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {record.get('url')}
                      </a>
                    </strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Email:</label>
                    <strong>{record.get('email')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Year Opened:</label>
                    <strong>{record.get('yearDeveloped')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Public/Private:</label>
                    <strong>{record.get('publicPrivate')}</strong>
                  </ListGroupItem>
                </ListGroup>
              </Col>
            </Row>
            <Row className={cx(cmpStyle.details, BS.gutters1)}>
              <Col xs={12} sm={4}>
                <div className={`${BS.p1}`}>
                  <h5>Description</h5>
                </div>
              </Col>
              <Col xs={12} sm={8}>
                <p
                  dangerouslySetInnerHTML={{
                    __html: record.get('description') || ''
                  }}
                />
              </Col>
            </Row>
            {isLoaded && !error && (
              <React.Fragment>
                <hr />
                <h5 className={BS.p1}>
                  {PROPERTY_SEARCH_TITLES[propertyClass]}
                  {record.get('name')}
                </h5>
                <Row className={cx(cmpStyle.details, BS.flex1)}>
                  <PropertySearch
                    golfCourseId={record.get('id')}
                    hideBreadcrumb
                    pathname={`/golf-course/${id}`}
                    pathnameAdvanced={`/golf-course/${id}/advanced`}
                    pathnameAdvancedResults={`/golf-course/${id}/advanced/results`}
                  />
                </Row>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </Container>
    );
  }

  componentWillMount() {
    this.checkAndLoad();
  }

  componentDidUpdate() {
    this.checkAndLoad();
  }

  checkAndLoad() {
    const { loaded, isLoading, error, load, id } = this.props;
    if ((!loaded || loaded !== id) && !isLoading && (!error || loaded !== id)) {
      load({ id });
    }
  }

  reload() {
    const { load, id } = this.props;

    if (load && id) {
      load({ id });
    }
  }

  getAddress({ address, city, state, zip }) {
    return compact([address, city, compact([state, zip]).join(', ')]).join(' ');
  }

  renderMap() {
    const { record } = this.props,
      lat = parseFloat(record.get('latitude'), 10),
      lng = parseFloat(record.get('longitude'), 10);

    return lat && lng ? (
      <div className={cmpStyle.map}>
        <PropertyDetailMap record={record} />
      </div>
    ) : null;
  }
}

export default connect(
  (state, props) => {
    const id = props.match.params.id;
    const { searchURI, detailURI } = URI(state.routing.location.search).search(true);
    const { pathname, search = {} } = state.routing.location;
    const query = URI(search).search(true);

    return {
      id,
      record: state.GolfCourseSearch.getIn(['detail', 'record']),
      isLoading: state.GolfCourseSearch.getIn(['detail', 'loading']),
      loaded: state.GolfCourseSearch.getIn(['detail', 'loaded']),
      error: state.GolfCourseSearch.getIn(['detail', 'error']),
      // These additional URIjs methods are being called to santitize the URL
      searchURI: searchURI
        ? URI(searchURI).protocol('').hostname('').port('').normalizePathname().toString()
        : '/find-golf-course',
      detailURI:
        detailURI &&
        URI(detailURI).protocol('').hostname('').port('').normalizePathname().toString(),
      currentURI:
        pathname &&
        URI(pathname).search(omit(query, 'detailURI', 'searchURI')).toString(),
      propertyClass: query.propertyClass || 'residential'
    };
  },
  { load: fetch }
)(GolfCourse);



// WEBPACK FOOTER //
// ./src/containers/GolfCourseDetail/GolfCourseDetail.js